import React from "react";
import { Box, Typography } from "@mui/material";
import { RiErrorWarningLine, RiInboxLine } from "@remixicon/react";
import { tokens } from "../../utils/figmaTokens";
import SmallButton from "./SmallButton";

// Empty State 10601:492 and Error State 10618:2251: an icon ring, a title, an optional line
// under it and small buttons (Users table 10661:11679, 10661:7994). `compact` is for a block
// inside a card.
const shellSx = (compact) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  gap: "6px",
  px: 3,
  py: compact ? 3 : 7,
});

const ringSx = (bg, color) => ({ display: "flex", p: "14px", borderRadius: "999px", bgcolor: bg, color });

// The states' small buttons (SmallButton, 047 step 5): solid brand, or outlined with the neutral
// 1.5 px border inside the same 32 px box. With `href` the button opens that address in a new tab
// (the tutor page's View, 047 step 4).
export const StateAction = ({ onClick, href, outlined = false, children }) => (
  <SmallButton
    tone={outlined ? "outline" : "solid"}
    onClick={onClick}
    {...(href ? { href, target: "_blank", rel: "noopener noreferrer" } : {})}
  >
    {children}
  </SmallButton>
);

const StateText = ({ title, message }) => (
  <>
    <Typography variant="bodySmallStrong" sx={{ color: tokens.text.primary }}>
      {title}
    </Typography>
    {message && (
      <Typography variant="bodySmall" sx={{ color: tokens.text.tertiary }}>
        {message}
      </Typography>
    )}
  </>
);

export const EmptyState = ({ title, message, actions, compact = false }) => (
  <Box sx={shellSx(compact)}>
    <Box sx={ringSx(tokens.surface.muted, tokens.text.tertiary)}>
      <RiInboxLine size={22} />
    </Box>
    <StateText title={title} message={message} />
    {actions && <Box sx={{ display: "flex", gap: "8px", pt: "10px" }}>{actions}</Box>}
  </Box>
);

export const ErrorState = ({ title, message, onRetry, compact = false }) => (
  <Box sx={shellSx(compact)} role="alert">
    <Box sx={ringSx(tokens.error.bg, tokens.error.ink)}>
      <RiErrorWarningLine size={22} />
    </Box>
    <StateText title={title} message={message} />
    {onRetry && (
      <Box sx={{ display: "flex", gap: "8px", pt: "10px" }}>
        <StateAction onClick={onRetry}>Retry</StateAction>
      </Box>
    )}
  </Box>
);
